import { RouteObject } from 'react-router-dom';

import LoginPage from '@/pages/login/page';
import DashboardPage from '@/pages/dashboard/page';

import AdminDashboardPage from '@/pages/admin-dashboard/page';
import AdminUserManagementPage from '@/pages/admin-user-management/page';
import AdminSystemConfigPage from '@/pages/admin-system-config/page';
import AdminLegalKnowledgePage from '@/pages/admin-legal-knowledge/page';
import AdminNotificationsPage from '@/pages/admin-notifications/page';
import AdminDataSecurityPage from '@/pages/admin-data-security/page';
import AdminAuditTrailPage from '@/pages/admin-audit-trail/page';
import AdminMaintenancePage from '@/pages/admin-maintenance/page';

import SupVictimReportsPage from '@/pages/sup-victim-reports/page';
import SupVictimReportDetailPage from '@/pages/sup-victim-report-detail/page';

import SupervisorDashboardPage from '@/pages/supervisor-dashboard/page';
import SupAIInsightsPage from '@/pages/sup-ai-insights/page';
import SupApprovalsPage from '@/pages/sup-approvals/page';
import SupEscalationPage from '@/pages/sup-escalation/page';
import SupOversightPage from '@/pages/sup-oversight/page';
import SupLegalPage from '@/pages/sup-legal/page';
import SupReportsPage from '@/pages/sup-reports/page';
import SupDecisionSupportPage from '@/pages/sup-decision-support/page';
import SupNotesPage from '@/pages/sup-notes/page';
import SupPerformancePage from '@/pages/sup-performance/page';
import SupNotificationsPage from '@/pages/sup-notifications/page';
import SupWalkInCaseDetailPage from "@/pages/sup-walkin-case-details/page";

import SWDashboardPage from '@/pages/sw-dashboard/page';
import SWCasesPage from '@/pages/sw-cases/page';
import SWAIDocPage from '@/pages/sw-ai-doc/page';
import SWFieldworkPage from '@/pages/sw-fieldwork/page';
import SWTrackingPage from '@/pages/sw-tracking/page';
import SWAlertsPage from '@/pages/sw-alerts/page';
import SWSubmitPage from '@/pages/sw-submit/page';
import SWCoordinationPage from '@/pages/sw-coordination/page';
import SWLegalPage from '@/pages/sw-legal/page';
import SWActivityPage from '@/pages/sw-activity/page';
import SWChildMonitoringPage from '@/pages/sw-child-monitoring/page';
import SWRaiseConcernPage from '@/pages/sw-raise-concern/page';
import SWRaiseConcernDetailPage from '@/pages/sw-raise-concern/detail';
import SWAssessmentPage from '@/pages/sw-assessment/page';
import SWAssessmentResultsPage from '@/pages/sw-assessment-results/page';
import SWMessagesPage from '@/pages/sw-messages/page';
import SWNotificationsPage from '@/pages/sw-notifications/page';
import SupCaseAssignmentPage from "@/pages/sup-case-assignment/page";

import CaseIntakePage from '@/pages/case-intake/page';

import ChildProfilesPage from '@/pages/child-profiles/page';
import ChildProfileDetail from '@/pages/child-profiles/detail';
import EditChild from '@/pages/child-profiles/edit';

import RiskAssessmentPage from '@/pages/risk-assessment/page';
import ReportsPage from '@/pages/reports/page';
import UserManagementPage from '@/pages/user-management/page';
import AlertsPage from '@/pages/alerts/page';
import ReferralsPage from '@/pages/referrals/page';
import SettingsPage from '@/pages/settings/page';
import CasesReviewPage from '@/pages/cases-review/page';
import MyCasesPage from '@/pages/my-cases/page';
import ArchivePage from '@/pages/archive/page';

import VDashboardPage from '@/pages/v-dashboard/page';
import VReportPage from '@/pages/v-report/page';
import VLawPage from '@/pages/v-law/page';
import VResourcesPage from '@/pages/v-resources/page';
import VProgressPage from '@/pages/v-progress/page';
import VMessagesPage from '@/pages/v-messages/page';
import VNotificationsPage from '@/pages/v-notifications/page';

import ProtectedRoute from '@/components/feature/ProtectedRoute';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />
  },

  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/admin-dashboard',
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminDashboardPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/admin-user-management',
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminUserManagementPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/admin-system-config',
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminSystemConfigPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/admin-legal-knowledge',
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminLegalKnowledgePage />
      </ProtectedRoute>
    )
  },

  {
    path: '/admin-notifications',
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminNotificationsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/admin-data-security',
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminDataSecurityPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/admin-audit-trail',
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminAuditTrailPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/admin-maintenance',
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <AdminMaintenancePage />
      </ProtectedRoute>
    )
  },

  {
    path: '/supervisor-dashboard',
    element: (
      <ProtectedRoute allowedRoles={['supervisor']}>
        <SupervisorDashboardPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-victim-reports',
    element: (
      <ProtectedRoute allowedRoles={['supervisor']}>
        <SupVictimReportsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-victim-reports/:reportUid',
    element: (
      <ProtectedRoute allowedRoles={['supervisor']}>
        <SupVictimReportDetailPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-walkin-case-details/:caseNumber',
    element: (
      <ProtectedRoute allowedRoles={['supervisor']}>
        <SupWalkInCaseDetailPage  />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-case-assignment',
    element: (
      <ProtectedRoute allowedRoles={['supervisor']}>
        <SupCaseAssignmentPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-notifications',
    element: (
      <ProtectedRoute allowedRoles={['supervisor']}>
        <SupNotificationsPage  />
      </ProtectedRoute>
    )
  },
  

  {
    path: '/sup-ai-insights',
    element: (
      <ProtectedRoute>
        <SupAIInsightsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-approvals',
    element: (
      <ProtectedRoute>
        <SupApprovalsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-escalation',
    element: (
      <ProtectedRoute>
        <SupEscalationPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-oversight',
    element: (
      <ProtectedRoute>
        <SupOversightPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-legal',
    element: (
      <ProtectedRoute>
        <SupLegalPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-reports',
    element: (
      <ProtectedRoute>
        <SupReportsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-decision-support',
    element: (
      <ProtectedRoute>
        <SupDecisionSupportPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-notes',
    element: (
      <ProtectedRoute>
        <SupNotesPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sup-performance',
    element: (
      <ProtectedRoute>
        <SupPerformancePage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-dashboard',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWDashboardPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-cases',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWCasesPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-ai-doc',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWAIDocPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-fieldwork',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWFieldworkPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-tracking',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWTrackingPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-alerts',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWAlertsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-submit',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWSubmitPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-coordination',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWCoordinationPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-child-monitoring',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWChildMonitoringPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-raise-concern',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWRaiseConcernPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-raise-concern/:report_uid',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWRaiseConcernDetailPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-assessment',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWAssessmentPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-assessment-results',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWAssessmentResultsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-legal',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWLegalPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-activity',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWActivityPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-messages',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWMessagesPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/sw-notifications',
    element: (
      <ProtectedRoute allowedRoles={['social_worker']}>
        <SWNotificationsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/case-intake',
    element: (
      <ProtectedRoute>
        <CaseIntakePage />
      </ProtectedRoute>
    )
  },

  {
    path: '/child-profiles',
    element: (
      <ProtectedRoute>
        <ChildProfilesPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/child-profiles/:case_number',
    element: (
      <ProtectedRoute>
        <ChildProfileDetail />
      </ProtectedRoute>
    )
  },

  {
    path: '/child-profiles/edit/:id',
    element: (
      <ProtectedRoute>
        <EditChild />
      </ProtectedRoute>
    )
  },

  {
    path: '/risk-assessment',
    element: (
      <ProtectedRoute>
        <RiskAssessmentPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/reports',
    element: (
      <ProtectedRoute>
        <ReportsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/user-management',
    element: (
      <ProtectedRoute>
        <UserManagementPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/alerts',
    element: (
      <ProtectedRoute>
        <AlertsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/referrals',
    element: (
      <ProtectedRoute>
        <ReferralsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/cases-review',
    element: (
      <ProtectedRoute>
        <CasesReviewPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/my-cases',
    element: (
      <ProtectedRoute>
        <MyCasesPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/archive',
    element: (
      <ProtectedRoute>
        <ArchivePage />
      </ProtectedRoute>
    )
  },

  {
    path: '/v-dashboard',
    element: (
      <ProtectedRoute allowedRoles={['victim']}>
        <VDashboardPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/v-report',
    element: (
      <ProtectedRoute allowedRoles={['victim']}>
        <VReportPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/v-law',
    element: (
      <ProtectedRoute allowedRoles={['victim']}>
        <VLawPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/v-resources',
    element: (
      <ProtectedRoute allowedRoles={['victim']}>
        <VResourcesPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/v-progress',
    element: (
      <ProtectedRoute allowedRoles={['victim']}>
        <VProgressPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/v-notifications',
    element: (
      <ProtectedRoute allowedRoles={['victim']}>
        <VNotificationsPage />
      </ProtectedRoute>
    )
  },

  {
    path: '/v-messages',
    element: (
      <ProtectedRoute allowedRoles={['victim']}>
        <VMessagesPage />
      </ProtectedRoute>
    )
  },

  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;